// Configuration AOS (Animate On Scroll)
// Ce fichier contient la configuration et l'initialisation d'AOS

(function ($, root, undefined) {
  'use strict';

  // Initialisation d'AOS avec configuration personnalisée
  function initAOS() {
    if (typeof AOS !== 'undefined') {
      AOS.init({
        // Configuration globale
        duration: 800,           // Durée des animations
        easing: 'ease-out-cubic', // Type d'easing
        once: true,              // Animation une seule fois
        mirror: false,           // Pas de miroir
        anchorPlacement: 'top-bottom', // Placement de l'ancre
        
        // Configuration responsive
        disable: 'mobile',       // Désactiver sur mobile pour les performances
        
        // Configuration des offsets
        offset: 120,             // Déclenchement à 120px du bas
        delay: 0,                // Pas de délai par défaut
        
        // Configuration des seuils
        threshold: 0.1,          // Seuil de déclenchement (10% visible)
        
        // Callbacks
        start: function() {
          // Animation commencée
          console.log('AOS animation started');
        },
        end: function() {
          // Animation terminée
          console.log('AOS animation ended');
        }
      });
    }
  }

  // Attendre que le DOM soit chargé
  $(document).ready(function() {
    initAOS();
  });

  // Réinitialiser AOS lors du changement de page (pour les SPA ou AJAX)
  $(window).on('load', function() {
    if (typeof AOS !== 'undefined') {
      AOS.refresh();
    }
  });

  // Réinitialiser AOS lors du redimensionnement de la fenêtre
  $(window).on('resize', function() {
    if (typeof AOS !== 'undefined') {
      AOS.refresh();
    }
  });

  // Exposer la fonction d'initialisation globalement
  window.initAOS = initAOS;

})(jQuery, this);
